import { render } from "./RoomChart.vue?vue&type=template&id=2ac08f6e"
import script from "./RoomChart.vue?vue&type=script&lang=js"
export * from "./RoomChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__